// this renders dropdown modal with navigation options (for both desktop and mobile views)
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import styled from 'styled-components'
import constants from '../../../constants/constants'
import styles from '../../../constants/styles'
import colors from '../../../constants/colors'

const paths = [
  { name: 'home', title: 'Home' },
  { name: 'feed', title: 'Feed' },
  { name: 'resources', title: 'Resources' },
  { name: 'account', title: 'Account' },
  { name: 'faq', title: 'FAQ + T&C' },
  { name: 'contact', title: 'Contact' }
]

class NavModal extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.handleClick = this.handleClick.bind(this)
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClick)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick)
  }

  handleClick() {
    const { closeModal } = this.props
    closeModal()
  }

  render() {
    const { username, logOut } = this.props
    return (
      <Container
        ref={(node) => {
          this.node = node
        }}
      >
        <MobileNavLinks>
          {paths.map(({ name, title }) => (
            <Link key={name} href={`/dashboard/${name}`}>
              <a>
                <Section>{title}</Section>
              </a>
            </Link>
          ))}
        </MobileNavLinks>
        <a
          href={`${constants.webURL}/users/${username}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Section>
            <span>Profile</span>
          </Section>
        </a>
        <Link href="/">
          <Section onClick={logOut}>
            <span>Log out</span>
          </Section>
        </Link>
      </Container>
    )
  }
}

NavModal.propTypes = {
  username: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  logOut: PropTypes.func.isRequired
}

export default NavModal

const Container = styled.div`
  width: 100%;
  max-width: calc(240px - 2 * ${styles.margin.small});
  max-height: 90vh;
  position: absolute;
  top: 64px;
  z-index: 60;
  right: 0px;
  background-color: ${styles.colors.white};
  border: 1px solid ${styles.colors.lightGrey};
  border-top: none;
  overflow: hidden;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  margin: ${styles.margin.small};
  margin-top: 0;

  @media (min-width: 449px) {
    width: 240px;
  }
`

const MobileNavLinks = styled.div`
  @media (min-width: 901px) {
    display: none;
  }
`

const Section = styled.div`
  padding: ${styles.padding.medium};
  font-size: 1em;
  color: ${styles.colors.black};
  border-bottom: ${(props) => (props.isLast ? 0 : '1px')} solid
    ${styles.colors.lightGrey};
  &:hover {
    background-color: ${styles.colors.lightGrey};
    color: ${colors.palette.primary.main};
  }
`
